import { ToastContainer } from 'react-toastify'

function Notification(props){
  return (
    <ToastContainer />
  )
}
export default (Notification);
